import React from "react";
import RFField from "../../../components/Form/RFField";
import { useRFFormContext } from "../../../components/Form/RFForm";
import { useEffect } from "react";

const ForgalomContentHelybenFormField = ({ onChange, helyben }) => {
  const { change } = useRFFormContext();

  useEffect(() => {
    change("helyben", helyben);
  }, [helyben]);

  return (
    <RFField
      type="select"
      name="helyben"
      label="Helyben fogyasztva:"
      onChange={onChange}
      value={helyben}
      defaultSelect={<option value="">Válassz értéket...</option>}
      selectOptions={
        <>
          <option value="true">Igen</option>
          <option value="false">Nem</option>
        </>
      }
    />
  );
};

export default ForgalomContentHelybenFormField;
